import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PowerBIService } from 'app/services/api/powerbi/powerbi.service';
import { Subscription } from 'rxjs';

declare var powerbi: any;

@Component({
    selector: 'app-reports-powerbi',
    templateUrl: './reports-powerbi.component.html',
    styleUrls: ['./reports-powerbi.component.scss'],
})
export class ReportsPowerBIComponent {
    private paramSubscription: Subscription;

    constructor(
        private route: ActivatedRoute,
        private powerBIService: PowerBIService,
        private router: Router
    ) {}

    ngAfterViewInit(): void {
        this.paramSubscription = this.route.queryParams.subscribe((p) => {
            let reportKey = this.route.snapshot.queryParamMap.get('key');
            this.renderReport(reportKey);
        });
    }

    ngOnDestroy(): void {
        this.paramSubscription.unsubscribe();
    }

    renderReport(reportKey: string) {
        this.powerBIService.getReport(reportKey).subscribe((report) => {
            // Get a reference to the embedded report HTML element
            const reportContainer = $('#embedContainer')[0];

            // Read report Id from Model
            const embedReportId = report.reportId;

            // You can embed different reports as per your need by changing the index
            // Read embed URL from Model
            const embedUrl =
                'https://app.powerbi.com/reportEmbed?reportId=' +
                embedReportId +
                '&groupId=2648587f-cf65-4888-9d87-9936965177f8&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLUVVUk9QRS1OT1JUSC1CLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0IiwiZW1iZWRGZWF0dXJlcyI6eyJtb2Rlcm5FbWJlZCI6dHJ1ZSwidXNhZ2VNZXRyaWNzVk5leHQiOnRydWV9fQ%3d%3d';

            // Get models. models contains enums that can be used.
            const models = window['powerbi-client'].models;

            // Embed configuration used to describe the what and how to embed.
            // This object is used when calling powerbi.embed.
            // This also includes settings and options such as filters.
            // You can find more information at https://github.com/Microsoft/PowerBI-JavaScript/wiki/Embed-Configuration-Details.
            const config = {
                type: 'report',
                tokenType: models.TokenType.Embed,
                accessToken: report.token,
                embedUrl: embedUrl,
                id: embedReportId,
                permissions: models.Permissions.All,
                settings: {
                    // Enable this setting to remove gray shoulders from embedded report
                    // background: models.BackgroundType.Transparent,
                    filterPaneEnabled: true,
                    navContentPaneEnabled: true,
                },
            };

            // Embed the report and display it within the div container.
            powerbi.embed(reportContainer, config);
        });
    }
}
